import React, { useEffect } from 'react'
import TextField from '@mui/material/TextField';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import { searchProducts } from '../../networkCalls';

const HeaderSearchCel = () => {
    const [searchText, setSearchText] = React.useState('');
    const searchTextChange = e => {
        setSearchText(e.target.value);
    };

    const [productResult, setProductResult] = React.useState([]);
    const [categoryResult, setCategoryResult] = React.useState([]);
    const callSearchAPI = (value) => {
        var data = new FormData();
        data.append('searchKeyword', value);
        searchProducts(data).then((res) => {
            switch (res.data.status) {
                case 1:
                    setProductResult(res.data.ProductList);
                    setCategoryResult(res.data.CategoryList);
                    return true;
                case 0:
                    break;
                default:
                    return;
            }
        })
    }
    useEffect(() => {
        if (searchText && searchText?.length > 1) {
            callSearchAPI(searchText)
        }
    }, [searchText]);

    const popResult = searchText.length > 1;
    return (
        <>
            <div className='header__search'>
                <div className='search'>
                    <div className='search__body'>
                        <div className='search__shadow'></div>
                        {/* <IconButton disabled className='search__button search__button--start m-2'>
                            <CategoryIcon />
                        </IconButton> */}
                        <TextField
                            id="standard-basic"
                            label="Search By Products Name"
                            variant="standard"
                            InputLabelProps={{ min: 0, style: { width: '100%', fontSize: '16px', top: '-3px', transformOrigin: 'top center', color: '#999' } }}
                            inputProps={{ min: 0, style: { textAlign: 'center' } }}
                            className='w-100 ms-3 me-3 text-center srachhanner'
                            size="small"
                            value={searchText}
                            onChange={searchTextChange}
                        />
                        {/* <IconButton className='search__button m-2'>
                            <SearchIcon />
                        </IconButton> */}
                        <div className="search__decor">
                            <div className="search__decor-start"></div>
                            <div className="search__decor-end"></div>
                        </div>
                        <div className={`search__dropdown search__dropdown--suggestions suggestions ${popResult ? 'search__dropdown--open' : ''}`}>
                            <div className="suggestions__group">
                                {productResult && productResult?.length > 0 ? <div className='p_search_wrap'>
                                    <div className="text-uppercase txtlgeay text-uppercase f12 ps-3 pb-2 fw-bold">Products</div>
                                    <div className="ps-3 pe-3">
                                        {productResult && productResult?.length > 0 && productResult?.map((data, key) => (
                                            <a href={`/product-detail/${data?.slug}`} key={key}  >
                                                <div className="d-flex text-black mb-2">
                                                    <div className="">
                                                        <img alt="" className='border p-1' src={data?.image} style={{ width: '50px' }} />
                                                    </div>
                                                    <div className="flex-grow-1 ps-2 pe-2">
                                                        <div className='f13'>{data?.name}</div>
                                                        <div className='txtlgeay f12 pt-1'>{data?.catLabel}</div>
                                                    </div>
                                                    <div className="fw-bold"><CurrencyRupeeIcon className='f12 fw-bold' />{data?.price}</div>
                                                </div>
                                            </a>
                                        ))}
                                    </div>
                                </div> : <div className='text-center'>NO PRODUCT FOUND</div>}
                                <hr className='mb-2' />
                                {categoryResult && categoryResult?.length > 0 ? <div className='p_search_cat_wrap'>
                                    <div className="text-uppercase txtlgeay text-uppercase f12 ps-3 pb-2 fw-bold">CATEGORIES</div>
                                    <div className="ps-3 pe-3">
                                        {categoryResult && categoryResult?.length > 0 && categoryResult?.map((data, key) => (
                                            <a href={`/product-category/${data?.catSlug}`} key={key}  >
                                                <div className="d-flex text-black mb-2 align-items-center">
                                                    <div><img alt="" className='border p-1' src={data?.catImage} style={{ width: '50px' }} /></div>
                                                    <div className="flex-grow-1 ps-2 ">
                                                        <div className="f12 fw-bold">{data?.catLabel}</div>
                                                    </div>
                                                </div>
                                            </a>
                                        ))}
                                    </div>
                                </div> : <></>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default HeaderSearchCel